import React from 'react';
import { Link } from 'react-router-dom';

const RecipeCard = ({ recipe, index }) => {
	const getDifficultyBadge = (difficulty) => {
		const difficultyMap = {
			easy: { text: 'Einfach', class: 'bg-warning' },
			medium: { text: 'Mittel', class: 'bg-warning' },
			hard: { text: 'Schwer', class: 'bg-warning' },
		};
		return difficultyMap[difficulty] || { text: 'Unbekannt', class: 'bg-secondary' };
	};

	const getCuisineBadge = (cuisine) => {
		return { text: cuisine, class: 'badge-primary' };
	};

	const getTimeBadge = (totalTime) => {
		// Convert PT25M to 25 Min format
		const timeMatch = totalTime.match(/PT(\d+)M/);
		const minutes = timeMatch ? timeMatch[1] : '0';
		return { text: `${minutes} Min`, class: 'bg-success' };
	};

	const difficulty = getDifficultyBadge(recipe.difficulty);
	const cuisine = getCuisineBadge(recipe.recipeCuisine);
	const time = getTimeBadge(recipe.totalTime);

	const isEven = index % 2 === 0;

	return (
		<div className="container recipe-card">
			<div className="row align-items-center">
				{isEven ? (
					<>
						<div className="col-12 col-lg-6 text-end order-1 order-lg-1">
							<Link to={`/rezept/${recipe.id}`} className="text-decoration-none">
								<img src={recipe.image} alt={recipe.name} className="recipe-image img-fluid rounded mx-auto d-block mb-5" style={{ cursor: 'pointer' }} />
							</Link>
						</div>
						<div className="col-12 col-lg-6 order-2 order-lg-2">
							<Link to={`/rezept/${recipe.id}`} className="text-decoration-none">
								<h2 className="display-6 fw-bold mb-3 text-black" style={{ cursor: 'pointer' }}>
									{recipe.name}
								</h2>
							</Link>
							<div className="d-flex align-items-center mb-3">
								<span className={`badge ${cuisine.class} me-2`}>{cuisine.text}</span>
								<span className={`badge ${difficulty.class} me-2`}>{difficulty.text}</span>
								<span className={`badge ${time.class}`}>{time.text}</span>
							</div>
							<p className="lead mb-4">{recipe.description}</p>
							<Link to={`/rezept/${recipe.id}`} className="btn btn-primary btn-lg">
								Rezept ansehen
							</Link>
						</div>
					</>
				) : (
					<>
						<div className="col-12 col-lg-6 text-center order-1 order-lg-2">
							<Link to={`/rezept/${recipe.id}`} className="text-decoration-none">
								<img src={recipe.image} alt={recipe.name} className="recipe-image img-fluid rounded mb-5" style={{ cursor: 'pointer' }} />
							</Link>
						</div>
						<div className="col-12 col-lg-6 order-2 order-lg-1">
							<Link to={`/rezept/${recipe.id}`} className="text-decoration-none">
								<h2 className="display-6 fw-bold mb-3 text-black" style={{ cursor: 'pointer' }}>
									{recipe.name}
								</h2>
							</Link>
							<div className="d-flex align-items-center mb-3">
								<span className={`badge ${cuisine.class} me-2`}>{cuisine.text}</span>
								<span className={`badge ${difficulty.class} me-2`}>{difficulty.text}</span>
								<span className={`badge ${time.class}`}>{time.text}</span>
							</div>
							<p className="lead mb-4">{recipe.description}</p>
							<Link to={`/rezept/${recipe.id}`} className="btn btn-primary btn-lg">
								Rezept ansehen
							</Link>
						</div>
					</>
				)}
			</div>
		</div>
	);
};

export default RecipeCard;
